import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';

export const useToast = () => {
  const { showSuccess, showError } = useStore(
    useShallow(state => ({
      showSuccess: state.showSuccess,
      showError: state.showError,
    }))
  );

  return {
    success: showSuccess,
    error: showError,
  };
};
